/* global Rutter */

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['button']
  static values = { platform: String, publicKey: String }

  initialize() {
    const script_url = "https://cdn.jsdelivr.net/npm/@rutter/rutter-link@latest";

    if (!document.querySelector(`script[src="${script_url}"]`)) {
      const script = document.createElement("script");
      script.src = script_url;
      script.async = true;
      script.onload = () => console.log("Rutter script loaded");
      script.onerror = () => console.error("Rutter script failed to load");
      document.head.appendChild(script);
    }
  }

  connect() {
    this.disableButtons();

    // Wait for the Rutter global to be available.
    const startTime = Date.now();
    const interval = setInterval(() => {
      if (typeof Rutter !== "undefined") {
        clearInterval(interval);
        this.enableButtons();
      }
      // If 60 seconds have passed, stop waiting and re-enable the buttons.
      if (Date.now() - startTime > 60000) {
        clearInterval(interval);
        console.error("Rutter script failed to load within 1 minute.");
      }
    }, 100);

  }

  disableButtons() {
    this.buttonTargets.forEach(button => {
      button.disabled = true;
    });
  }

  enableButtons() {
    this.buttonTargets.forEach(button => {
      button.disabled = false;
    });
  }

  loadRutter() {
    this.openRutter();
  }

  openRutter() {
    this.disableButtons();
    // Create an instance of Rutter and open the widget.
    const rutterInstance = Rutter.create({
      publicKey: this.publicKeyValue,
      onSuccess: (publicToken) => {
        this.callBackendAPI(this.buttonTarget, publicToken);
      },
      onExit: (errorEnum) => {
        console.log(errorEnum);
        this.enableButtons();
      }
    });

    if (this.hasPlatformValue) {
      rutterInstance.open({ platform: this.platformValue });
    } else {
      rutterInstance.open();
    }
  }

  callBackendAPI(buttonTarget, publicToken) {
    const accountId = buttonTarget.dataset.rutterAccountId;
    const url = buttonTarget.dataset.rutterUrl.replace(":id", accountId);

    fetch(url, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': this.token,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ public_token: publicToken, account_id: accountId })
    })
    .then(response => response.json())
    .then(data => {
      if (data.id != null && data.platform_type === 'commerce') {
        window.location.href = `/integrations/commerce/${data.id}/setup`;
      } else {
        window.location.href = `/integrations/accounting/${data.id}/setup`;
      }
    });
  }

  get token() {
    return document.querySelector('meta[name="csrf-token"]').getAttribute('content');
  }
}
